import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import _ from 'lodash'
import get from 'lodash/get'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import { Button, Container, Row, Col, Modal } from 'reactstrap'
import {
  authAction,
  divisionAction,
  teamAction,
  modalAction,
} from './../../actions/'
import {
  authSelector,
  divisionSelector,
  teamSelector,
  modalSelector,
} from './../../selectors'
import { searchTeams } from '../../function'
import Searchbar from '../../components/searchbar'
import withLayout from '../../helpers/withLayout'
import EditTeam from './edit'
import ListTeam from './list'
import TeamForm from '../../components/team'
import CustomModal from '../../components/modal'
import CustomModalMessage from '../../components/modal-message'
import moment from '../../lib/moment.js'

class TeamPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      edit: false,
      id: '',
      span: false,
      team_code: '',
      team: '',
      division_id: '',
      start_date: '',
      search: '',
      defaultTeams: [],
      teams: [],
    }
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleSpan = this.handleSpan.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.showForm = this.showForm.bind(this)
    this.cancelForm = this.cancelForm.bind(this)
    this.showDiscard = this.showDiscard.bind(this)
    this.cancelDiscard = this.cancelDiscard.bind(this)
    this.showDelete = this.showDelete.bind(this)
    this.cancelDelete = this.cancelDelete.bind(this)
    this.cancelAlert = this.cancelAlert.bind(this)
    this.showSave = this.showSave.bind(this)
    this.cancelSave = this.cancelSave.bind(this)
    this.handleClickSearch = this.handleClickSearch.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handleDivision = this.handleDivision.bind(this)
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    this.props.listDivision(access_token)
  }
  componentWillReceiveProps(nextProps) {
    if (_.get(nextProps, 'teamList') && this.state.search === '') {
      this.setState({
        teams: _.get(nextProps, 'teamList'),
        defaultTeams: _.get(nextProps, 'teamList'),
      })
    }
    if (_.get(nextProps, 'teamCreate.teamCreate')) {
      this.props.listTeam(localStorage.getItem('access_token'))
      this.props.showModal(
        'team',
        _.get(nextProps, 'teamCreate.status'),
        _.get(nextProps, 'teamCreate.message')
      )
      this.props.resetCreateTeam()
    }
    if (_.get(nextProps, 'teamEdit.teamEdit')) {
      this.setState({
        edit: false,
      })
      this.props.showModal(
        'team',
        _.get(nextProps, 'teamEdit.status'),
        _.get(nextProps, 'teamEdit.message')
      )
      if (_.get(nextProps, 'teamEdit.status') === 200) this.showSave()
      this.props.listTeam(localStorage.getItem('access_token'))
      this.props.resetEditTeam()
      this.handleClickEdit(false, '')
    }
    if (_.get(nextProps, 'teamDeactivate.teamDeactivate')) {
      this.props.showConfirm(
        'deleteTeam',
        _.get(nextProps, 'teamDeactivate.status'),
        _.get(nextProps, 'teamDeactivate.message')
      )
      this.props.listTeam(localStorage.getItem('access_token'))
      this.props.resetDeactivateTeam()
    }
    if (_.get(nextProps, 'exportURL')) {
      window.open(_.get(nextProps, 'exportURL'), 'blank')
      this.props.resetExportTeam()
    }
  }
  handleClickSearch() {
    this.setState({ teams: _.get(this.state, 'defaultTeams').filter(searchTeams, this.state.search) })
  }
  handleSearch(e) {
    if (e.keyCode === 13) this.handleClickSearch()
    else if (e.target.value === '') this.setState({ teams: _.get(this.state, 'defaultTeams'), search: '' })
    else this.setState({ search: e.target.value })
  }
  handleClickEdit(editTeam, team_id) {
    this.setState({
      edit: editTeam,
      id: team_id,
    })
  }
  handleInput(e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  handleSpan(spanList) {
    this.setState({ span: spanList })
  }
  handleDivision(e) {
    this.setState({ division_id: e.division_code })
  }
  showSave() {
    this.props.showConfirm('confirmSave', 'Saved Successfully', 'Your team information had been saved.')
  }
  cancelSave() {
    this.props.hideConfirm('confirmSave')
  }
  showDelete() {
    this.props.showConfirm('confirmDelete', 'Delete Comfirmation', 'Are you sure to delete ?')
  }
  cancelDelete() {
    this.props.hideConfirm('confirmDelete')
  }
  showDiscard() {
    this.props.showConfirm('confirmDiscard', 'Discard Changes', 'Are you sure you want to discard all changes ?')
  }
  cancelDiscard() {
    this.props.hideConfirm('confirmDiscard')
  }
  showForm() {
    this.handleClickEdit(false, '')
    this.handleSpan(false)
    this.props.showModal('teamForm')
  }
  cancelForm() {
    this.props.hideModal('teamForm')
  }
  cancelAlert() {
    this.props.hideModal('team')
  }
  submitForm() {
    this.props.createTeam(
      {
        team_code: this.state.team_code,
        name: this.state.team,
        division_id: _.get(this.state, 'division_id') === '' ? _.get(this.props, 'listDivisionData')[0]._id : _.get(this.state, 'division_id'),
        start_date: this.state.start_date === '' ? '' : moment(this.state.start_date),
      },
      localStorage.getItem('access_token'))
  }

  render() {
    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    || get(this.props, 'redirectTeam.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
      || get(this.props, 'redirectTeam.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }

    const button = (
      <div>
        <NewButton color="success" onClick={ this.submitForm }>Create</NewButton>
      </div>
    )
    const buttonOK = (
      <div>
        <NewButton color="info" onClick={ this.cancelSave }>OK</NewButton>
      </div>
    )
    const isFetching = get(this.props, 'getIsFetchingDivision')
    || get(this.props, 'getIsFetchingTeam')
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        <Searchbar
          export={ () => this.props.exportTeam(localStorage.getItem('access_token')) }
          toggleCreate={ this.showForm }
          handleSearch={ this.handleSearch }
          handleClickSearch={ this.handleClickSearch }
          search={ this.state.search }
        />
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        {
          _.get(this.props, 'modalType') === 'team' &&
            <CustomModal
              hide={ this.cancelAlert }
              show={ _.get(this.props, 'modalType') === 'team' }
              type={ _.get(this.props, 'modalStatus') }
              message={ _.get(this.props, 'modalMessage') }
            />
        }
        {
          _.get(this.props, 'confirmType') === 'confirmSave' &&
          <CustomModalMessage
            hide={ this.cancelSave }
            show={ _.get(this.props, 'confirmType') === 'confirmSave' }
            type={ _.get(this.props, 'confirmStatus') }
            message={ _.get(this.props, 'confirmMessage') }
            button={ buttonOK }
          />
        }
        {
          _.get(this.props, 'confirmType') === 'deleteTeam' &&
          <CustomModalMessage
            hide={ this.cancelSave }
            show={ _.get(this.props, 'confirmType') === 'deleteTeam' }
            type={ _.get(this.props, 'confirmStatus') }
            message={ _.get(this.props, 'confirmMessage') }
            button={ buttonOK }
          />
        }
        <Row noGutters>
          <Col>
            <ListTeam
              handleClickEdit={ this.handleClickEdit }
              handleSpan={ this.handleSpan }
              span={ this.state.span }
              teams={ this.state.teams }
              table={ 8 }
            />
          </Col>
          {
            this.state.span && <Col>
              <EditTeam
                edit={ this.state }
                handleClickEdit={ this.handleClickEdit }
                handleSpan={ this.handleSpan }
                cancelForm={ this.cancelForm }
                showDelete={ this.showDelete }
                cancelDelete={ this.cancelDelete }
                showDiscard={ this.showDiscard }
                cancelDiscard={ this.cancelDiscard }
                confirm={ _.get(this.props, 'confrimType') }
                confirmStatus={ _.get(this.props, 'confirmStatus') }
                confirmType={ _.get(this.props, 'confirmType') }
                confirmMessage={ _.get(this.props, 'confirmMessage') }
              />
            </Col>
          }
        </Row>
        <Modal isOpen={ _.get(this.props, 'modalType') === 'teamForm' } toggle={ this.cancelForm }>
          <TeamForm
            create={ true }
            list={ _.get(this.props, 'listDivisionData') }
            confirm={ _.get(this.props, 'modalType') }
            button={ button }
            team_code={ this.state.team_code }
            team={ this.state.team }
            division_id={ this.state.division_id }
            start_date={ this.state.start_date }
            submitForm={ this.submitForm }
            handleClickEdit={ this.handleClickEdit }
            handleInput={ this.handleInput }
            handleDivision={ this.handleDivision }
            cancelForm={ this.cancelForm }
            modalStatus={ _.get(this.props, 'modalStatus') }
            modalType={ _.get(this.props, 'modalType') }
          />
        </Modal>
      </Wrapper>
    )
  }
}

TeamPage.propTypes = {
  createTeam: PropTypes.func.isRequired,
  resetCreateTeam: PropTypes.func.isRequired,
  listDivision: PropTypes.func.isRequired,
  listTeam: PropTypes.func.isRequired,
  resetEditTeam: PropTypes.func.isRequired,
  resetDeactivateTeam: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  redirectAuth: authSelector.redirectAuth,
  redirectTeam: teamSelector.redirectTeam,
  getIsFetchingDivision: divisionSelector.getIsFetching,
  getIsFetchingTeam: teamSelector.getIsFetching,
  listDivisionData: divisionSelector.getListDivision,
  teamCreate: teamSelector.getCreateTeamData,
  teamEdit: teamSelector.getEditTeamData,
  teamGet: teamSelector.getGetTeamData,
  teamList: teamSelector.getListTeam,
  teamDeactivate: teamSelector.getDeactivateTeamData,
  exportURL: teamSelector.getExportURL,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  createTeam: teamAction.createTeam,
  resetCreateTeam: teamAction.resetCreateTeam,
  resetEditTeam: teamAction.resetEditTeam,
  resetDeactivateTeam: teamAction.resetDeactivateTeam,
  listDivision: divisionAction.getDivision,
  listTeam: teamAction.getTeam,
  exportTeam: teamAction.exportTeam,
  resetExportTeam: teamAction.resetExportTeam,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withLayout(TeamPage))

const Wrapper = styled(Container)`
  padding: 0px;
  background-color: #F1F1F1;
`
const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/team/index.js